import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/matteklar';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-69" data-mp="e3dgfowuf8og">
      <div className="mx-auto max-w-6xl" data-id="element-70" data-mp="9vyg8jt240j">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-71" data-mp="58z6m1v30qcq">
          <div className="lg:col-span-7" data-id="element-72" data-mp="574gm94ye81s">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-73" data-mp="3mgugxw4z8jv3">Forskjellen med NATURFAG KLAR™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-74" data-mp="3rhi76fldswo9">
              Fra stresset lærer til <em className="text-red-700" data-id="element-75" data-mp="3diqzpc10y993">trygg og forberedt.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-76" data-mp="3ihv7by8avyxb">
            Tenk deg å starte uka med naturfagtimene allerede organisert. Du vet hva du skal
            undervise i – og du har øktene, arbeidsarkene i 3 nivåer, fasiten
            og vurderingskriteriene.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-77" data-mp="1f9k1o0mf9orq">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-78" data-mp="1t1i45slmomex" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-79" data-mp="1o488vwbk5gj6">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-80" data-mp="10e4gkl3tl37h">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-81" data-mp="1aa7dncjtebnk">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-82" data-mp="1abs8l3a1jwly">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-83" data-mp="15a2z3s2gvqzz">Før NATURFAG KLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-84" data-mp="2lo2wav9xh2jj">
              Kjenner du deg igjen?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-85" data-mp="2oriphkr7laph">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-86" data-mp="2ss2oktvceoe9">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-87" data-mp="2xt8iuw4nijpw" />
                  <span data-id="element-88" data-mp="32pp6lp7xuw2g">
                    <span className="block font-semibold text-slate-900/80" data-id="element-89" data-mp="32q8nr3prlgff">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-90" data-mp="2a09wr2s0f984">
            <p className="text-sm font-semibold text-red-300" data-id="element-91" data-mp="2js5u2bm9uvba">Med NATURFAG KLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-92" data-mp="2ju8vdrsvkavb">
              Planlegg mindre. Undervis mer.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-93" data-mp="1rbbpd37oxeve">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-94" data-mp="1jslt8ddw3ge1">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-95" data-mp="1euamwcmszo0k">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="19sl9iqc3yy9b" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-97" data-mp="10vkqkz7t5sd9">
          Fokuser på elevene dine – ikke på å lage alt materiellet selv.
        </p>
      </div>
    </section>;
}